import { render } from "./Column202602.vue?vue&type=template&id=5467c380&scoped=true"
import script from "./Column202602.vue?vue&type=script&lang=js"
export * from "./Column202602.vue?vue&type=script&lang=js"

import "./Column202602.vue?vue&type=style&index=0&id=5467c380&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5467c380"

export default script